module.exports = __webpack_public_path__ + "static/media/search_not_found.ec98ed1a.svg";